module.exports = __webpack_public_path__ + "assets/public/imgs/network-policy-samples/1-deny-other-namespaces.svg";